/**
 * @file: useNavigateToTaskDetail.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { TaskNavParams } from '@euler/app/flows/task/TaskFlow';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { useCallback } from 'react';

export const useNavigateToTaskDetail = () => {
  const navigation = useNavigation<StackNavigationProp<TaskNavParams>>();
  return useCallback(() => {
    navigation.navigate('taskDetail', {});
  }, [navigation]);
};
